import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";
import { teamPageSsrProps } from "shared/pages/teams/ssr/routesProps";
import UserFeedPage from "shared/pages/userFeed/UserFeedPage";

const ShopContext = lazy(() => import('shared/pages/Shop/ShopContext'));
const TeamAdminList = lazy(() => import('shared/pages/teams/teamAdminList'));
const TeamEdit = lazy(() => import('shared/pages/teams/TeamEdit'));
const GroupPage = lazy(() => import('shared/pages/groups'));
const EmployeesContext = lazy(() => import('../../_deziiign/hsedesign/pages/EmployeesContext'));
const EmployeesModerContext = lazy(() => import('../../_deziiign/hsedesign/pages/EmployeesModerContext'));
const ExploreHseContextsExternal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsExternal'));
const TeamFormPage = lazy(() => import("shared/pages/teams/TeamFormPage"));
const TeamFormTable = lazy(() => import("shared/pages/teams/TeamFormTable"));
const TeamBilingual = lazy(() => import('shared/pages/TeamBilingual'));
const TeamPreview = lazy(() => import('shared/pages/teams/components/TeamPreview'));
const TeamsAdminPage = lazy(() => import('../../_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage'));
const ChatPage = lazy(() => import('shared/pages/ChatPage/ChatPage'));

const teamRoutes = [
    { path: '/team/:teamName/shop', exact: true, component: ShopContext },
    { path: '/teams/:teamName/shop', exact: true, component: ShopContext },
    { path: LinkTo.employeesAdmin, exact: true, component: TeamsAdminPage },
    { path: LinkTo.ShopLocal, exact: true, isPrivate: true, component: () => <ShopContext isGeneralContext /> },
    { path: LinkTo.teamAdmin, exact: true, isPrivate: true, component: TeamAdminList },
    { path: LinkTo.teamEdit, exact: true, isPrivate: true, component: TeamEdit },
    { path: LinkTo.teamCreate, exact: true, isPrivate: true, component: TeamEdit },
    { path: LinkTo.previewTeamLongread, exact: true, component: TeamPreview },
    { path: LinkTo.previewTeam, exact: true, component: ExploreHseContextsExternal },
    { path: LinkTo.teamBilingual, exact: true, component: TeamBilingual },
    { path: '/team/:teamName/employees', exact: true, component: EmployeesContext },
    { path: '/team/:teamName/employees/moder', exact: true, component: EmployeesModerContext },
    { path: '/teams/:teamName/employees', exact: true, component: EmployeesContext },
    { path: '/teams/:teamName/employees/moder', exact: true, component: EmployeesModerContext },
    { path: '/teams/:teamName/employees/group/:groupId', exact: true, component: GroupPage },
    { path: '/teams/:teamName', exact: true, component: ExploreHseContextsExternal, ...teamPageSsrProps },
    { path: '/teams/:teamName/brnd', exact: true, component: ExploreHseContextsExternal, ...teamPageSsrProps },
    { path: '/form/:formId', exact: true, component: TeamFormPage },
    { path: '/form_data/:formId', isPrivate: true, exact: true, component: TeamFormTable },
    { path: '/teams/form/:formId', exact: true, component: TeamFormPage },
    { path: '/teams/form_data/:formId', isPrivate: true, exact: true, component: TeamFormTable },
    { path: '/chat/:teamName', exact: true, component: ChatPage },
    { path: LinkTo.feed, exact: true, component: UserFeedPage },
];  

export default teamRoutes;import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";
import { teamPageSsrProps } from "shared/pages/teams/ssr/routesProps";
import UserFeedPage from "shared/pages/userFeed/UserFeedPage";

const ShopContext = lazy(() => import('shared/pages/Shop/ShopContext'));
const TeamAdminList = lazy(() => import('shared/pages/teams/teamAdminList'));
const TeamEdit = lazy(() => import('shared/pages/teams/TeamEdit'));
const GroupPage = lazy(() => import('shared/pages/groups'));
const EmployeesContext = lazy(() => import('../../_deziiign/hsedesign/pages/EmployeesContext'));
const EmployeesModerContext = lazy(() => import('../../_deziiign/hsedesign/pages/EmployeesModerContext'));
const ExploreHseContextsExternal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsExternal'));
const TeamFormPage = lazy(() => import("shared/pages/teams/TeamFormPage"));
const TeamFormTable = lazy(() => import("shared/pages/teams/TeamFormTable"));
const TeamBilingual = lazy(() => import('shared/pages/TeamBilingual'));
const TeamPreview = lazy(() => import('shared/pages/teams/components/TeamPreview'));
const TeamsAdminPage = lazy(() => import('../../_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage'));
const ChatPage = lazy(() => import('shared/pages/ChatPage/ChatPage'));

const teamRoutes = [
    { path: '/team/:teamName/shop', exact: true, component: ShopContext },
    { path: '/teams/:teamName/shop', exact: true, component: ShopContext },
    { path: LinkTo.employeesAdmin, exact: true, component: TeamsAdminPage },
    { path: LinkTo.ShopLocal, exact: true, isPrivate: true, component: () => <ShopContext isGeneralContext /> },
    { path: LinkTo.teamAdmin, exact: true, isPrivate: true, component: TeamAdminList },
    { path: LinkTo.teamEdit, exact: true, isPrivate: true, component: TeamEdit },
    { path: LinkTo.teamCreate, exact: true, isPrivate: true, component: TeamEdit },
    { path: LinkTo.previewTeamLongread, exact: true, component: TeamPreview },
    { path: LinkTo.previewTeam, exact: true, component: ExploreHseContextsExternal },
    { path: LinkTo.teamBilingual, exact: true, component: TeamBilingual },
    { path: '/team/:teamName/employees', exact: true, component: EmployeesContext },
    { path: '/team/:teamName/employees/moder', exact: true, component: EmployeesModerContext },
    { path: '/teams/:teamName/employees', exact: true, component: EmployeesContext },
    { path: '/teams/:teamName/employees/moder', exact: true, component: EmployeesModerContext },
    { path: '/teams/:teamName/employees/group/:groupId', exact: true, component: GroupPage },
    { path: '/teams/:teamName', exact: true, component: ExploreHseContextsExternal, ...teamPageSsrProps },
    { path: '/teams/:teamName/brnd', exact: true, component: ExploreHseContextsExternal, ...teamPageSsrProps },
    { path: '/form/:formId', exact: true, component: TeamFormPage },
    { path: '/form_data/:formId', isPrivate: true, exact: true, component: TeamFormTable },
    { path: '/teams/form/:formId', exact: true, component: TeamFormPage },
    { path: '/teams/form_data/:formId', isPrivate: true, exact: true, component: TeamFormTable },
    { path: '/chat/:teamName', exact: true, component: ChatPage },
    { path: LinkTo.feed, exact: true, component: UserFeedPage },
];  

export default teamRoutes;